exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.li[data-v-36800681] {\n  text-align: justify;\n}\ntextarea[data-v-36800681] {\n  margin-top: 1rem;\n}\nbutton[data-v-36800681] {\n  margin-top: -1rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-36800681","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Decisions.vue
// module id = 1VZ/
// module chunks = 97